import angular from 'angular';


const ngEnter = angular.module('ttb.directives.ngEnter', [])
    .directive('ngEnter', () => {
        return (scope, element, attrs) => {
            element.bind('keydown keypress', event => {
                if (event.which === 13) {
                    scope.$apply(() => scope.$eval(attrs.ngEnter));
                    event.preventDefault();
                }
            });
        };
    })
    .name;

export default ngEnter;


// WEBPACK FOOTER //
// ../directives/ng-enter.js